import {ExamRequestResultTypeEnum} from 'domain/usecases/private/exam-results/get-exam-requests';
import {translations} from 'presentation/translations-new';

const {examTypeLabel} = translations['pt-br'].privateFlow.examResults;

const EXAM_TYPE_OPTIONS = {
	[ExamRequestResultTypeEnum.VARIED]: {
		label: examTypeLabel.assortedExam,
	},
	[ExamRequestResultTypeEnum.IMAGE]: {
		label: examTypeLabel.imagingExam,
	},
	[ExamRequestResultTypeEnum.LABORATORY]: {
		label: examTypeLabel.laboratoryExam,
	},
};

export {EXAM_TYPE_OPTIONS};
